export default {
  admin: 'admin',
  accounting: 'accounting',
  superintendent: 'superintendent',
  baseUser: 'baseUser',
};

export let RoleDisplay = {
  admin: 'Admin',
  accounting: 'Accounting',
  superintendent: 'Superintendent',
  baseUser: 'Base User',
};
